import React from "react";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    title: "How to Keep Your PC Running Fast",
    excerpt: "Simple maintenance tips to improve speed, stability, and everyday performance.",
  },
  {
    title: "5 Signs Your Business Needs IT Support",
    excerpt: "Spot common warning signs before small tech issues turn into costly downtime.",
  },
  {
    title: "Backups That Actually Protect Your Data",
    excerpt: "Learn the backup habits that help keep your files safe and recoverable.",
  },
];

export default function BlogSection() {
  return (
    <section className="bg-[#0f0f14] text-white py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-red-500 font-semibold uppercase tracking-widest">
            Latest Insights
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mt-3">
            Helpful articles for smarter tech decisions
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article
              key={index}
              className="bg-[#18181f] rounded-2xl p-6 border border-white/10"
            >
              <h3 className="text-xl font-semibold mb-3">{post.title}</h3>
              <p className="text-gray-300 mb-5">{post.excerpt}</p>
              <Link to="/blog" className="text-red-400 font-medium hover:underline">
                Read more
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
